import React, { FC } from 'react';
import cx from 'classnames';

import { SectionTwoColumns } from '@/components/organisms/SectionTwoColumns/render';

import block from './block.json';

export type HeaderAProps = {
	hasButtons?: boolean;
	hasImage?: boolean;
} & SectionTwoColumnsProps;

/**
 * COMPONENT
 */
export const HeaderA: FC<HeaderAProps> & BlockConfigs = ({
	hasImage = true,
	...props
}) => {
	const rootClass = cx(
		props.className,
		props.hasButtons && 'supt-section--hasButtons',
		hasImage && 'supt-section--hasImage'
	);

	return <SectionTwoColumns {...props} titleTag="h1" className={rootClass} />;
};

HeaderA.slug = block.slug;
HeaderA.title = block.title;
